import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { isValueEmpty, isObjectEmpty } from '@awp/helpers/utilsReact';
import { SENSOR_PLACEMENT_CONFIG, STATE_STATUS } from '@awp/constants';
import {
  setEditing,
  setPlacement,
  setOrignPlacement,
  setSaveStatus,
  setSaveError,
  savePlacement,
  setData,
  getWeatherStationId,
  getCurrentSensorEquipmentPacket,
  getSelectedPlacement,
  getOrignPlacement,
  getSensorTypes,
  getSaveStatus,
  getSaveError,
} from '@stores/sensorEquipmentPacketSlice';
import { Crud } from '@awp/shared/Crud';

const CreateSensorPlacementModal = ({ visible, closeModal }) => {
  const dispatch = useDispatch();
  const sensorTypeList = useSelector(getSensorTypes);
  const weatherStationId = useSelector(getWeatherStationId);
  const currentSensorEquipmentPacket = useSelector(getCurrentSensorEquipmentPacket);
  const selectedPlacement = useSelector(getSelectedPlacement);
  const selectedOrignPlacement = useSelector(getOrignPlacement);
  const saveError = useSelector(getSaveError);
  const [show, setShow] = useState(visible);
  const [stError, setStError] = useState(false);

  const crud = new Crud('Sensor Placement');

  const handleClose = useCallback(() => {
    removeEmptyPlacement();
    cleanData();
    setStError(false);
    closeModal();
  }, [currentSensorEquipmentPacket]);

  useEffect(() => {
    setStError(false);
    setShow(visible);
  }, [visible]);

  const removeEmptyPlacement = () => {
    let _data = { ...currentSensorEquipmentPacket };
    let _sensorEquipmentSets = [..._data.SensorEquipmentSets];
    let _newSensorEquipmentSets = [];
    _sensorEquipmentSets.map((sp) => {
      if (sp.SensorPlacementId !== SENSOR_PLACEMENT_CONFIG.ID) _newSensorEquipmentSets.push(sp);
    });

    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
  };

  const cleanData = () => {
    dispatch(setEditing(null));
    dispatch(setOrignPlacement(null));
    dispatch(setPlacement(null));
    dispatch(setSaveError(null));
  };

  const createNewSensorPlacement = (e) => {
    setStError(false);
    const sensorTypeId = e.value + '';
    const st = sensorTypeList.find((opt) => opt.value == sensorTypeId);

    let newSensorPlacement = {
      SensorPlacementId: SENSOR_PLACEMENT_CONFIG.ID,
      SensorTypeId: sensorTypeId,
      SensorTypeName: st.label,
      PlacementName: getPlacementNumber(st.displayName),
      WeatherStationId: weatherStationId,
      StructuredAttributes: st.PlacementAttributeSchema,
      SensorObservationTypes: [],
      IsCollapsed: 2, ////0/1 collapsed//2 expanded
    };

    dispatch(setPlacement(newSensorPlacement));
    dispatch(setEditing(SENSOR_PLACEMENT_CONFIG.PLACEMENT_TAG + newSensorPlacement.SensorPlacementId));
  };
  const getPlacementNumber2 = (placementName) => {
    let _currentSensorEquipmentPacket = { ...currentSensorEquipmentPacket };
    let maxNumber = 0;
    let count = 0;
    if (_currentSensorEquipmentPacket && _currentSensorEquipmentPacket.SensorEquipmentSets) {
      _currentSensorEquipmentPacket.SensorEquipmentSets.forEach((sensorEquipmentSet) => {
        if (sensorEquipmentSet.PlacementName && sensorEquipmentSet.PlacementName.startsWith(placementName)) {
          const number = parseInt(sensorEquipmentSet.PlacementName.substring(placementName.length), 10);
          if (!isNaN(number)) {
            maxNumber = Math.max(maxNumber, number);
          }
          count++;
        }
      });
    }
    if (count === 1 && maxNumber === 0) {
      return placementName + '2';
    } else if (count === 0) {
      return placementName;
    } else {
      return placementName + (maxNumber + 1);
    }
  };
  const getPlacementNumber = (placementName) => {
    let _currentSensorEquipmentPacket = { ...currentSensorEquipmentPacket };
    let maxNumber = 0;
    let count = 0;
    let pattern = /(\[\d+\])$/;
    let lastNumber = '';
    let newName = '';

    // Check if placementName ends with a number in brackets
    if (pattern.test(placementName)) {
      lastNumber = pattern.exec(placementName)[0];
      newName = placementName.replace(pattern, '');
    } else {
      newName = placementName;
    }

    if (_currentSensorEquipmentPacket && _currentSensorEquipmentPacket.SensorEquipmentSets) {
      _currentSensorEquipmentPacket.SensorEquipmentSets.forEach((sensorEquipmentSet) => {
        if (sensorEquipmentSet.PlacementName && sensorEquipmentSet.PlacementName.startsWith(newName)) {
          let number = 0;

          // Check if placementName ends with a number in brackets
          if (pattern.test(sensorEquipmentSet.PlacementName)) {
            number = parseInt(pattern.exec(sensorEquipmentSet.PlacementName)[0].replace(/\D/g, ''), 10);
          }

          if (number > maxNumber) {
            maxNumber = number;
          }
          count++;
        }
      });
    }

    if (count === 1 && maxNumber === 0) {
      return newName + ' [2]';
    } else if (count === 0) {
      return newName;
    } else {
      return newName + ' [' + (maxNumber + 1) + lastNumber + ']';
    }
  };

  const handlePlacementSubmit = () => {
    let _selectedPlacement = { ...selectedPlacement };
    if (isValueEmpty(_selectedPlacement.SensorTypeId)) {
      setStError(true);
      return;
    }
    let _data = { ...currentSensorEquipmentPacket };
    let _sensorEquipmentSets = _data.SensorEquipmentSets;
    let _newSensorEquipmentSets = [];
    _newSensorEquipmentSets.push(_selectedPlacement);
    _sensorEquipmentSets.map((sp) => {
      _newSensorEquipmentSets.push(sp);
    });
    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
    closeModal();
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>{crud.getModalTitle()}</Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            <b>Select sensor type</b>
          </Form.Label>
          <br />
          <Select options={sensorTypeList} placeholder={'Select ...'} onChange={createNewSensorPlacement} />
          {stError && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {'Sensor type is required.'}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handlePlacementSubmit}>
          Create Placement
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CreateSensorPlacementModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default CreateSensorPlacementModal;
